import { render, staticRenderFns } from "./RemoveCompanyGroupDialog.vue?vue&type=template&id=28b5c46a&"
import script from "./RemoveCompanyGroupDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveCompanyGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports